module.exports = __webpack_public_path__ + "static/media/heart-filled.2a3c7234.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/heart-filled.svg
// module id = 1901
// module chunks = 0